import React from 'react';

const UnderConstruction = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>Under Construction</h1>
            <p style={styles.message}>
                We're working hard.
                Please check back soon!
            </p>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        textAlign: 'center',
        fontFamily: 'sans-serif',
    },
    title: {
        fontSize: '2.5rem',
        marginBottom: '1rem',
    },
    message: {
        fontSize: '1.2rem',
        color: '#555',
    },
};

export default UnderConstruction;